/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_JoggingInputs */

const en_homepage_listen_in_jogging = /** @type {(inputs: Homepage_Listen_In_JoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogging`)
};

const es_homepage_listen_in_jogging = /** @type {(inputs: Homepage_Listen_In_JoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corriendo`)
};

/**
* | output |
* | --- |
* | "Jogging" |
*
* @param {Homepage_Listen_In_JoggingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_jogging = /** @type {((inputs?: Homepage_Listen_In_JoggingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_JoggingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_jogging(inputs)
	return en_homepage_listen_in_jogging(inputs)
});